import React, { Component } from "react";
// import ExperienceCard from "../../components/experienceCard/ExperienceCard.js";
import "./ExperienceAccordion.css";
import WorkIMG from './work'
import {Chrono} from 'react-chrono'

class ExperienceAccordion extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="timeline_div">
        <div className="work_img">
          <WorkIMG theme={theme}/>
        </div>
        { this.props.sections.length > 0 ? 
        <div className="timeline">
          <Chrono items={this.props.sections} mode="TREE" 
          slideShow={true} theme={{primary: theme.dark, textColor:theme.text, secondary: theme.highlight}} 
          slideItemDuration={2000}
          />
        </div> : <h1 className="no_exp">Nothing to show off about my Experience</h1>}
      </div>
      // <div className="experience-accord">
      //   <Accordion onChange={({ expanded }) => console.log(expanded)}>
      //     {this.props.sections.map((section) => {
      //       return (
      //         <Panel
      //           className="accord-panel"
      //           title={section["title"]}
      //           key={section["title"]}
      //         >
      //           {section["experiences"].length > 0 ? section["experiences"].map((experience) => {
      //             return (
      //               <ExperienceCard experience={experience} theme={theme} />
      //             );
      //           }): 
      //             <h1 style={{textAlign:"center",color:theme.text}}>Nothing to show off myself :(</h1>
      //            }
      //         </Panel>
      //       );
      //     })}
      //   </Accordion>
      // </div>
    );
  }
}

export default ExperienceAccordion;
